<template>
    <div>
        <div class="box" :value="value"
             v-on:dragenter="ondrag"
             v-on:dragleave="ondrag"
             v-on:dragover="ondragover"
             v-on:drop="ondrop"
        >
            点击上传或将文件拖拽至此处
        </div>
    </div>
</template>

<script>
    export default {
        name: "BDragDropBox",
        props: {
            actionFunction: Function,
            value: Object,
        },
        data() {
            return {
                queue: [],
                lock: false,
                uuid: null,
            }
        },

        watch: {},

        methods: {
            ondrag(event) {
                event.preventDefault();
                event.stopPropagation();
                event.target.classList.toggle("boxHover");
            },
            ondragover(event) {
                event.preventDefault();
                event.stopPropagation();
            },
            ondrop(event) {
                event.preventDefault();
                event.stopPropagation();
                event.target.classList.remove("boxHover");
                for (let i = 0; i < event.dataTransfer.files.length; i++) {
                    this.queue.push(event.dataTransfer.files[i]);
                }
                this.go();
            },
            go() {
                if (typeof this.actionFunction !== "undefined") {
                    if (this.lock === false && this.queue.length !== 0) {
                        let target = this.queue[0];
                        this.uuid = this.create_UUID();
                        this.value.data.push({
                            uuid: this.uuid,
                            name: target.name,
                        })
                        this.queue.shift();

                        this.lock = true;
                        let promise = this.actionFunction(target, this.callback);
                        let self = this;
                        promise.then(
                            function (retval) {
                                for (let i = 0; i < self.value.data.length; i++) {
                                    let data = self.value.data[i];
                                    if (self.uuid === data.uuid) {
                                        data.retval = retval;
                                        break;
                                    }
                                }
                                self.triggerEmit();
                                self.$emit("input", self.value);
                                self.lock = false;
                                self.go();
                            }
                        );
                    }
                }
            },
            callback(value) {
                for (let i = 0; i < this.value.data.length; i++) {
                    let data = this.value.data[i];
                    if (this.uuid === data.uuid) {
                        data.loaded = value.loaded;
                        data.total = value.total;
                        data.progress = (value.loaded / value.total) * 100;
                        this.triggerEmit(this.value);
                        this.$emit("input", this.value);
                        break;
                    }
                }
            },
            create_UUID() {
                var dt = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (dt + Math.random() * 16) % 16 | 0;
                    dt = Math.floor(dt / 16);
                    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid;
            },
            triggerEmit(){
                if(this.value.dummy === 1){
                    this.value.dummy = 0;
                } else {
                    this.value.dummy = 1;
                }
            }
        }
    }
</script>

<style scoped>
    .box {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 100px;
        min-height: 273px;
        background: #F4FAFD;
        border: 1px solid #85D2F5;
        font-size: 16px;
        font-weight: 400;
        color: #0171A3;
    }

    .boxHover {
        background: #e6ebee;
    }
</style>